import { axiosBase, errorHandler } from "./axios";


const getEnrollmentParams = (data: any) => {
  return axiosBase.get("enrolment/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const createEnrollment = (data: any) => {
  return axiosBase.post("enrolment/save", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const deleteEnrollment = (data: any) => {
  return axiosBase.delete(`enrolment/delete/${data}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getEnrollmentView = (data: any) => {
  return axiosBase.get(`enrolment/view/${data.id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const toggleEnrollment = (data: any) => {
  return axiosBase.post(`enrolment/save`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const exportEnrollment = (data: any) => {
  return axiosBase.get("enrolment/export", { 
    params: data,
    responseType: 'blob' // Important for file downloads
  })
    .then((response) => response)
    .catch((error) => errorHandler(error));
}

const assignApplication = (data: any) => {
  return axiosBase.post("enrolment/assignApplication", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

export const enrollmentService = {
  getEnrollmentParams,
  createEnrollment,
  deleteEnrollment,
  getEnrollmentView,
  toggleEnrollment,
  exportEnrollment,
  assignApplication
};
